import type { Invoice, InvoiceAdd, InvoiceUpdate } from "../models/invoice";
import { createCrudStoreBundle } from "./crud.store";
import { type ApiClient, runStoreAction } from "./shared";

export type InvoiceEntity = Invoice;

export const createInvoicesStore = (apiClient: ApiClient) => {
	const bundle = createCrudStoreBundle<InvoiceEntity, InvoiceAdd, InvoiceUpdate>({
		apiClient,
		entityPath: "invoices",
	});

	const fetchAll = async (): Promise<readonly InvoiceEntity[]> => {
		const state = bundle.useStore.getState();
		return runStoreAction(state.setLoading, state.setError, async () => {
			const invoices = await apiClient.get<InvoiceEntity[]>("/get/invoices");
			bundle.useStore.getState().upsertMany(invoices);
			return invoices;
		});
	};

	return {
		useStore: bundle.useStore,
		actions: {
			...bundle.actions,
			fetchAll,
		},
	};
};
